import React, { useRef, useEffect } from 'react';
import InfiniteScrollProps from './types';

const InfiniteScroll: React.FC<InfiniteScrollProps> = ({
  onLoadMore,
  hasMore,
  children
}) => {
  const sentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && hasMore) {
        onLoadMore();
      }
    });
    if (sentinelRef.current) observer.observe(sentinelRef.current);

    return () => observer.disconnect();
  }, [onLoadMore, hasMore]);

  return (
    <>
      {children}
      <div ref={sentinelRef} />
    </>
  );
};

export default InfiniteScroll;
